import OwnerCard from "./OwnerCard";
import InsuredCard from "./InsuredCard";

const OwnerAndInsuredCard = ({ policyDetail }) => {
  const owners = policyDetail?.multipleOwner;

  const insureds = policyDetail?.multipleInsured;

  return (
    <>
      {owners?.length > 0 &&
        owners.map((owner) => (
          <OwnerCard
            key={`owner card - ${owner.person.fullName}`}
            owner={owner}
          />
        ))}

      {insureds?.length > 0 && (
        <InsuredCard
          insureds={insureds}
          effectiveDate={policyDetail.effectiveDate}
          policyDetail={policyDetail}
        />
      )}
    </>
  );
};

export default OwnerAndInsuredCard;
